import moment from "moment";

function OneToTenOptions({ value, onChange, previous, latestSurvey }) {

    const t = [1, 2, 3, 4, 5], b = [6, 7, 8, 9, 10];

    let cn;
    let rounded = Math.round(previous);
    let rounded2 = Math.round(value);
    let date = moment(latestSurvey?.created_at).format("DD/MM/YYYY");
    return (
        <div id="one-to-ten-options-wrapper">
            <div id="one-to-ten-options">
                <div className="ottp-top">
                    {
                        t.map(n => {
                            cn = "";
                            if (rounded2) {
                                if (rounded2 == n) {
                                    cn = "g-purp";
                                }
                            }

                            return <div className={cn} onClick={() => { onChange(n) }}>
                                {
                                    rounded == n && <div className="prev-indicator" />
                                }
                                <h4>{n}</h4>
                            </div>
                        })
                    }
                </div>
                <div className="ottp-bottom">
                    {
                        b.map(n => {
                            cn = "";
                            if (rounded2) {
                                if (rounded2 == n) {
                                    cn = "g-purp";
                                }
                            }

                            return <div className={cn} onClick={() => { onChange(n) }}>
                                {
                                    rounded == n && <div className="prev-indicator" />
                                }
                                <h4>{n}</h4>
                            </div>;
                        })
                    }
                </div>
            </div>

            {
                previous &&
                <div className="prev-score-wrapper">
                    <div className="prev-indicator" />
                    {/* <h6 className="prev-score" style={{ marginTop: "10px" }}>Previous Score({date}): {rounded}</h6> */}
                    <p className="prev-score">Previous Rating</p>
                    <p className="prev-score">{date}</p>
                </div>
            }

        </div>
    );
}

export default OneToTenOptions;